import { render, staticRenderFns } from "./organism_selection.vue?vue&type=template&id=4f0eb168&scoped=true&"
import script from "./organism_selection.vue?vue&type=script&lang=js&"
export * from "./organism_selection.vue?vue&type=script&lang=js&"
import style0 from "./organism_selection.vue?vue&type=style&index=0&id=4f0eb168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0eb168",
  null
  
)

export default component.exports